import { StyledLabel } from 'components/Inputs/styled';
import React, { FC } from 'react';
import { FieldError } from 'react-hook-form';

import { StyledCounter, StyledLabelRow } from './fieldLabelWithCounterStyled';

interface FieldLabelWithCounterProps {
  htmlFor?: string;
  label: string;
  counterText: string;
  error?: FieldError;
  counterExceeded?: boolean;
}

const FieldLabelWithCounter: FC<FieldLabelWithCounterProps> = ({
  htmlFor,
  label,
  counterText,
  error,
  counterExceeded = false,
}) => (
  <StyledLabelRow>
    <StyledLabel htmlFor={htmlFor} error={error}>
      {label}
    </StyledLabel>
    <StyledCounter counterExceeded={counterExceeded}>
      {counterText}
    </StyledCounter>
  </StyledLabelRow>
);

export default FieldLabelWithCounter;
